/**
 * Utility functions for handling custom emojis in the application
 */

// List of available emojis - must match the filenames in public/emojis folder
export const availableEmojis = [
  "hesitant", "cookie", "sigma", "wave", "blank", "laugh", "gasp", 
  "freaky", "tears", "shrug", "devious", "scared", "snicker", "nervous", 
  "think", "innocent", "sad", "goofy", "desperate", "plead", "thumbsup", 
  "drool", "argue", "cheer", "suspicious", "evil"
];

// Create a regular expression to match emoji codes like :laugh:
export const emojiPattern = new RegExp(
  `:(?:${availableEmojis.join('|')}):`, 'g'
);

/**
 * Processes a text string and replaces emoji codes with HTML for emoji images
 * @param {string} text - The text to process
 * @returns {string} - Text with emoji codes replaced with HTML
 */
export const processEmojis = (text) => {
  if (!text) return '';
  
  // Create a copy of the pattern to avoid regex lastIndex issues
  const pattern = new RegExp(emojiPattern);
  
  return text.replace(pattern, (match) => {
    // Extract emoji name from the match (remove the colons)
    const emojiName = match.substring(1, match.length - 1);
    
    // Check if this emoji is in our available list
    if (!availableEmojis.includes(emojiName)) {
      return match; // Return the original text if not a valid emoji
    }
    
    // Return HTML for the emoji image
    return `<img src="/emojis/${emojiName}.png" alt=":${emojiName}:" title=":${emojiName}:" class="inline-emoji" />`;
  });
};

/**
 * Checks if a string contains any emoji codes
 * @param {string} text - The text to check
 * @returns {boolean} - True if text contains emoji codes
 */
export const containsEmojis = (text) => {
  if (!text) return false;
  return emojiPattern.test(text);
};

/**
 * Gets all available emoji data for the emoji picker
 * @returns {Array} - Array of emoji objects with name and path
 */
export const getEmojiData = () => {
  return availableEmojis.map(emoji => ({
    name: emoji,
    path: `/emojis/${emoji}.png`
  }));
}; 